import React from 'react'
import Table from './Table'
import ShipTable from './ShipTable';

function Tab5({deliveryNoteData,deliveryNoteItems}) {
    console.log(deliveryNoteItems,"new_data_check");
    
  return (
    <div style={{ padding: '16px 24px' }}>
      <ShipTable deliveryNoteData={deliveryNoteData}  deliveryNoteItems={deliveryNoteItems}/>
    </div>
  )
}

export default Tab5
